import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-text");
import { style as _style, fallbackVar } from '@vanilla-extract/css';
import { shimmerStyles } from '@paypalcorp/pp-react-shimmer';
import { tokens, breakpoints } from '@paypalcorp/pp-react-theme';
import { contextColors } from '@paypalcorp/pp-react-utils';
function style(rule, debugId) {
  return [_style(rule, debugId), rule];
}
const getFontFamily = fontType => `${fontType}, "Helvetica Neue", Arial, sans-serif`;
export const overrideDefault = _style({
  margin: 0,
  padding: 0
}, 'text_override_default');
export const [body, bodyStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.body.family),
  fontSize: tokens.typography.body.size,
  lineHeight: tokens.typography.body.lineHeight,
  fontWeight: tokens.typography.body.weight,
  letterSpacing: tokens.typography.body.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.body.size}, calc(${tokens.typography.body.size}*${tokens.typography.body.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.body.lineHeight}, calc(${tokens.typography.body.lineHeight}*${tokens.typography.body.maxScaleFactor}))`
    }
  }
}, 'text-body');
export const [bodyMedium, bodyMediumStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.bodyMedium.family),
  fontSize: tokens.typography.bodyMedium.size,
  lineHeight: tokens.typography.bodyMedium.lineHeight,
  fontWeight: tokens.typography.bodyMedium.weight,
  letterSpacing: tokens.typography.bodyMedium.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.bodyMedium.size}, calc(${tokens.typography.bodyMedium.size}*${tokens.typography.bodyMedium.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.bodyMedium.lineHeight}, calc(${tokens.typography.bodyMedium.lineHeight}*${tokens.typography.bodyMedium.maxScaleFactor}))`
    }
  }
}, 'text-body_medium');
export const [bodyStrong, bodyStrongStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.bodyStrong.family),
  fontSize: tokens.typography.bodyStrong.size,
  lineHeight: tokens.typography.bodyStrong.lineHeight,
  fontWeight: tokens.typography.bodyStrong.weight,
  letterSpacing: tokens.typography.bodyStrong.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.bodyStrong.size}, calc(${tokens.typography.bodyStrong.size}*${tokens.typography.bodyStrong.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.bodyStrong.lineHeight}, calc(${tokens.typography.bodyStrong.lineHeight}*${tokens.typography.bodyStrong.maxScaleFactor}))`
    }
  }
}, 'text-body_strong');
export const [caption, captionStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.caption.family),
  fontSize: tokens.typography.caption.size,
  lineHeight: tokens.typography.caption.lineHeight,
  fontWeight: tokens.typography.caption.weight,
  letterSpacing: tokens.typography.caption.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.caption.size}, calc(${tokens.typography.caption.size}*${tokens.typography.caption.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.caption.lineHeight}, calc(${tokens.typography.caption.lineHeight}*${tokens.typography.caption.maxScaleFactor}))`
    }
  }
}, 'text-caption');
export const [captionMedium, captionMediumStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.captionMedium.family),
  fontSize: tokens.typography.captionMedium.size,
  lineHeight: tokens.typography.captionMedium.lineHeight,
  fontWeight: tokens.typography.captionMedium.weight,
  letterSpacing: tokens.typography.captionMedium.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.captionMedium.size}, calc(${tokens.typography.captionMedium.size}*${tokens.typography.captionMedium.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.captionMedium.lineHeight}, calc(${tokens.typography.captionMedium.lineHeight}*${tokens.typography.captionMedium.maxScaleFactor}))`
    }
  }
}, 'text-caption_medium');
export const [captionStrong, captionStrongStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.captionStrong.family),
  fontSize: tokens.typography.captionStrong.size,
  lineHeight: tokens.typography.captionStrong.lineHeight,
  fontWeight: tokens.typography.captionStrong.weight,
  letterSpacing: tokens.typography.captionStrong.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.captionStrong.size}, calc(${tokens.typography.captionStrong.size}*${tokens.typography.captionStrong.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.captionStrong.lineHeight}, calc(${tokens.typography.captionStrong.lineHeight}*${tokens.typography.captionStrong.maxScaleFactor}))`
    }
  }
}, 'text-caption_strong');
export const [linkLg, linkLgStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.linkLg.family),
  fontSize: tokens.typography.linkLg.size,
  lineHeight: tokens.typography.linkLg.lineHeight,
  fontWeight: tokens.typography.linkLg.weight,
  letterSpacing: tokens.typography.linkLg.letterSpacing,
  textDecoration: tokens.typography.linkLg.underline ? 'underline' : 'none',
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.linkLg.size}, calc(${tokens.typography.linkLg.size}*${tokens.typography.linkLg.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.linkLg.lineHeight}, calc(${tokens.typography.linkLg.lineHeight}*${tokens.typography.linkLg.maxScaleFactor}))`
    }
  }
}, 'text-link_lg');
export const [linkSm, linkSmStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.linkSm.family),
  fontSize: tokens.typography.linkSm.size,
  lineHeight: tokens.typography.linkSm.lineHeight,
  fontWeight: tokens.typography.linkSm.weight,
  letterSpacing: tokens.typography.linkSm.letterSpacing,
  textDecoration: tokens.typography.linkSm.underline ? 'underline' : 'none',
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.linkSm.size}, calc(${tokens.typography.linkSm.size}*${tokens.typography.linkSm.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.linkSm.lineHeight}, calc(${tokens.typography.linkSm.lineHeight}*${tokens.typography.linkSm.maxScaleFactor}))`
    }
  }
}, 'text-link_sm');
export const [tag, tagStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.tag.family),
  fontSize: tokens.typography.tag.size,
  lineHeight: tokens.typography.tag.lineHeight,
  fontWeight: tokens.typography.tag.weight,
  letterSpacing: tokens.typography.tag.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.tag.size}, calc(${tokens.typography.tag.size}*${tokens.typography.tag.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.tag.lineHeight}, calc(${tokens.typography.tag.lineHeight}*${tokens.typography.tag.maxScaleFactor}))`
    }
  }
}, 'text-tag');
export const [tagMedium, tagMediumStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.tagMedium.family),
  fontSize: tokens.typography.tagMedium.size,
  lineHeight: tokens.typography.tagMedium.lineHeight,
  fontWeight: tokens.typography.tagMedium.weight,
  letterSpacing: tokens.typography.tagMedium.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.tagMedium.size}, calc(${tokens.typography.tagMedium.size}*${tokens.typography.tagMedium.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.tagMedium.lineHeight}, calc(${tokens.typography.tagMedium.lineHeight}*${tokens.typography.tagMedium.maxScaleFactor}))`
    }
  }
}, 'text-tag_medium');
export const [tagStrong, tagStrongStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.tagStrong.family),
  fontSize: tokens.typography.tagStrong.size,
  lineHeight: tokens.typography.tagStrong.lineHeight,
  fontWeight: tokens.typography.tagStrong.weight,
  letterSpacing: tokens.typography.tagStrong.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.tagStrong.size}, calc(${tokens.typography.tagStrong.size}*${tokens.typography.tagStrong.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.tagStrong.lineHeight}, calc(${tokens.typography.tagStrong.lineHeight}*${tokens.typography.tagStrong.maxScaleFactor}))`
    }
  }
}, 'text-tag_strong');
export const [dataViz, dataVizStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.dataViz.family),
  fontSize: tokens.typography.dataViz.size,
  lineHeight: tokens.typography.dataViz.lineHeight,
  fontWeight: tokens.typography.dataViz.weight,
  letterSpacing: tokens.typography.dataViz.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.dataViz.size}, calc(${tokens.typography.dataViz.size}*${tokens.typography.dataViz.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.dataViz.lineHeight}, calc(${tokens.typography.dataViz.lineHeight}*${tokens.typography.dataViz.maxScaleFactor}))`
    }
  }
}, 'text-data_viz');
export const [dataVizMedium, dataVizMediumStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.dataVizMedium.family),
  fontSize: tokens.typography.dataVizMedium.size,
  lineHeight: tokens.typography.dataVizMedium.lineHeight,
  fontWeight: tokens.typography.dataVizMedium.weight,
  letterSpacing: tokens.typography.dataVizMedium.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.dataVizMedium.size}, calc(${tokens.typography.dataVizMedium.size}*${tokens.typography.dataVizMedium.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.dataVizMedium.lineHeight}, calc(${tokens.typography.dataVizMedium.lineHeight}*${tokens.typography.dataVizMedium.maxScaleFactor}))`
    }
  }
}, 'text-data_viz_medium');
export const [dataVizStrong, dataVizStrongStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.dataVizStrong.family),
  fontSize: tokens.typography.dataVizStrong.size,
  lineHeight: tokens.typography.dataVizStrong.lineHeight,
  fontWeight: tokens.typography.dataVizStrong.weight,
  letterSpacing: tokens.typography.dataVizStrong.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.dataVizStrong.size}, calc(${tokens.typography.dataVizStrong.size}*${tokens.typography.dataVizStrong.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.dataVizStrong.lineHeight}, calc(${tokens.typography.dataVizStrong.lineHeight}*${tokens.typography.dataVizStrong.maxScaleFactor}))`
    }
  }
}, 'text-data_viz_strong');
export const [title, titleStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.title.family),
  fontSize: tokens.typography.title.size,
  lineHeight: tokens.typography.title.lineHeight,
  fontWeight: tokens.typography.title.weight,
  letterSpacing: tokens.typography.title.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.title.size}, calc(${tokens.typography.title.size}*${tokens.typography.title.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.title.lineHeight}, calc(${tokens.typography.title.lineHeight}*${tokens.typography.title.maxScaleFactor}))`
    }
  }
}, 'text-title');
export const [titleMedium, titleMediumStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.titleMedium.family),
  fontSize: tokens.typography.titleMedium.size,
  lineHeight: tokens.typography.titleMedium.lineHeight,
  fontWeight: tokens.typography.titleMedium.weight,
  letterSpacing: tokens.typography.titleMedium.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.titleMedium.size}, calc(${tokens.typography.titleMedium.size}*${tokens.typography.titleMedium.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.titleMedium.lineHeight}, calc(${tokens.typography.titleMedium.lineHeight}*${tokens.typography.titleMedium.maxScaleFactor}))`
    }
  }
}, 'text-title_medium');
export const [titleStrong, titleStrongStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.titleStrong.family),
  fontSize: tokens.typography.titleStrong.size,
  lineHeight: tokens.typography.titleStrong.lineHeight,
  fontWeight: tokens.typography.titleStrong.weight,
  letterSpacing: tokens.typography.titleStrong.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.titleStrong.size}, calc(${tokens.typography.titleStrong.size}*${tokens.typography.titleStrong.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.titleStrong.lineHeight}, calc(${tokens.typography.titleStrong.lineHeight}*${tokens.typography.titleStrong.maxScaleFactor}))`
    }
  }
}, 'text-title_strong');
export const [headingSm, headingSmStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.headingSm.family),
  fontSize: tokens.typography.headingSm.size,
  lineHeight: tokens.typography.headingSm.lineHeight,
  fontWeight: tokens.typography.headingSm.weight,
  letterSpacing: tokens.typography.headingSm.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.headingSm.size}, calc(${tokens.typography.headingSm.size}*${tokens.typography.headingSm.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.headingSm.lineHeight}, calc(${tokens.typography.headingSm.lineHeight}*${tokens.typography.headingSm.maxScaleFactor}))`
    }
  }
}, 'text-heading_sm');
export const [headingSmMedium, headingSmMediumStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.headingSmMedium.family),
  fontSize: tokens.typography.headingSmMedium.size,
  lineHeight: tokens.typography.headingSmMedium.lineHeight,
  fontWeight: tokens.typography.headingSmMedium.weight,
  letterSpacing: tokens.typography.headingSmMedium.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.headingSmMedium.size}, calc(${tokens.typography.headingSmMedium.size}*${tokens.typography.headingSmMedium.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.headingSmMedium.lineHeight}, calc(${tokens.typography.headingSmMedium.lineHeight}*${tokens.typography.headingSmMedium.maxScaleFactor}))`
    }
  }
}, 'text-heading_sm_medium');
export const [headingSmStrong, headingSmStrongStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.headingSmStrong.family),
  fontSize: tokens.typography.headingSmStrong.size,
  lineHeight: tokens.typography.headingSmStrong.lineHeight,
  fontWeight: tokens.typography.headingSmStrong.weight,
  letterSpacing: tokens.typography.headingSmStrong.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.headingSmStrong.size}, calc(${tokens.typography.headingSmStrong.size}*${tokens.typography.headingSmStrong.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.headingSmStrong.lineHeight}, calc(${tokens.typography.headingSmStrong.lineHeight}*${tokens.typography.headingSmStrong.maxScaleFactor}))`
    }
  }
}, 'text-heading_sm_strong');
export const [headingLgStrong, headingLgStrongStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.headingLgStrong.family),
  fontSize: tokens.typography.headingLgStrong.size,
  lineHeight: tokens.typography.headingLgStrong.lineHeight,
  fontWeight: tokens.typography.headingLgStrong.weight,
  letterSpacing: tokens.typography.headingLgStrong.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.headingLgStrong.size}, calc(${tokens.typography.headingLgStrong.size}*${tokens.typography.headingLgStrong.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.headingLgStrong.lineHeight}, calc(${tokens.typography.headingLgStrong.lineHeight}*${tokens.typography.headingLgStrong.maxScaleFactor}))`
    }
  }
}, 'text-heading_lg_strong');
export const [headingLgMedium, headingLgMediumStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.headingLgMedium.family),
  fontSize: tokens.typography.headingLgMedium.size,
  lineHeight: tokens.typography.headingLgMedium.lineHeight,
  fontWeight: tokens.typography.headingLgMedium.weight,
  letterSpacing: tokens.typography.headingLgMedium.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.headingLgMedium.size}, calc(${tokens.typography.headingLgMedium.size}*${tokens.typography.headingLgMedium.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.headingLgMedium.lineHeight}, calc(${tokens.typography.headingLgMedium.lineHeight}*${tokens.typography.headingLgMedium.maxScaleFactor}))`
    }
  }
}, 'text-heading_lg_medium');
export const [headingLg, headingLgStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.headingLg.family),
  fontSize: tokens.typography.headingLg.size,
  lineHeight: tokens.typography.headingLg.lineHeight,
  fontWeight: tokens.typography.headingLg.weight,
  letterSpacing: tokens.typography.headingLg.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.headingLg.size}, calc(${tokens.typography.headingLg.size}*${tokens.typography.headingLg.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.headingLg.lineHeight}, calc(${tokens.typography.headingLg.lineHeight}*${tokens.typography.headingLg.maxScaleFactor}))`
    }
  }
}, 'text-heading_lg');
export const [displayLg, displayLgStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.display.family),
  fontSize: tokens.typography.display.size,
  lineHeight: tokens.typography.display.lineHeight,
  fontWeight: tokens.typography.display.weight,
  letterSpacing: tokens.typography.display.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.display.size}, calc(${tokens.typography.display.size}*${tokens.typography.display.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.display.lineHeight}, calc(${tokens.typography.display.lineHeight}*${tokens.typography.display.maxScaleFactor}))`
    }
  }
}, 'text-display');
export const [displayLgMedium, displayLgMediumStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.displayMedium.family),
  fontSize: tokens.typography.displayMedium.size,
  lineHeight: tokens.typography.displayMedium.lineHeight,
  fontWeight: tokens.typography.displayMedium.weight,
  letterSpacing: tokens.typography.displayMedium.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.displayMedium.size}, calc(${tokens.typography.displayMedium.size}*${tokens.typography.displayMedium.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.displayMedium.lineHeight}, calc(${tokens.typography.displayMedium.lineHeight}*${tokens.typography.displayMedium.maxScaleFactor}))`
    }
  }
}, 'text-display_medium');
export const [displayLgStrong, displayLgStrongStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.displayStrong.family),
  fontSize: tokens.typography.displayStrong.size,
  lineHeight: tokens.typography.displayStrong.lineHeight,
  fontWeight: tokens.typography.displayStrong.weight,
  letterSpacing: tokens.typography.displayStrong.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.displayStrong.size}, calc(${tokens.typography.displayStrong.size}*${tokens.typography.displayStrong.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.displayStrong.lineHeight}, calc(${tokens.typography.displayStrong.lineHeight}*${tokens.typography.displayStrong.maxScaleFactor}))`
    }
  }
}, 'text-display_strong');
export const [displaySm, displaySmStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.displaySm.family),
  fontSize: tokens.typography.displaySm.size,
  lineHeight: tokens.typography.displaySm.lineHeight,
  fontWeight: tokens.typography.displaySm.weight,
  letterSpacing: tokens.typography.displaySm.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.displaySm.size}, calc(${tokens.typography.displaySm.size}*${tokens.typography.displaySm.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.displaySm.lineHeight}, calc(${tokens.typography.displaySm.lineHeight}*${tokens.typography.displaySm.maxScaleFactor}))`
    }
  }
}, 'text-display_sm');
export const [displaySmMedium, displaySmMediumStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.displaySmMedium.family),
  fontSize: tokens.typography.displaySmMedium.size,
  lineHeight: tokens.typography.displaySmMedium.lineHeight,
  fontWeight: tokens.typography.displaySmMedium.weight,
  letterSpacing: tokens.typography.displaySmMedium.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.displaySmMedium.size}, calc(${tokens.typography.displaySmMedium.size}*${tokens.typography.displaySmMedium.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.displaySmMedium.lineHeight}, calc(${tokens.typography.displaySmMedium.lineHeight}*${tokens.typography.displaySmMedium.maxScaleFactor}))`
    }
  }
}, 'text-display_sm_medium');
export const [displaySmStrong, displaySmStrongStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.displaySmStrong.family),
  fontSize: tokens.typography.displaySmStrong.size,
  lineHeight: tokens.typography.displaySmStrong.lineHeight,
  fontWeight: tokens.typography.displaySmStrong.weight,
  letterSpacing: tokens.typography.displaySmStrong.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.displaySmStrong.size}, calc(${tokens.typography.displaySmStrong.size}*${tokens.typography.displaySmStrong.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.displaySmStrong.lineHeight}, calc(${tokens.typography.displaySmStrong.lineHeight}*${tokens.typography.displaySmStrong.maxScaleFactor}))`
    }
  }
}, 'text-display_sm_strong');
export const [legal, legalStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.legal.family),
  fontSize: tokens.typography.legal.size,
  lineHeight: tokens.typography.legal.lineHeight,
  fontWeight: tokens.typography.legal.weight,
  letterSpacing: tokens.typography.legal.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.legal.size}, calc(${tokens.typography.legal.size}*${tokens.typography.legal.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.legal.lineHeight}, calc(${tokens.typography.legal.lineHeight}*${tokens.typography.legal.maxScaleFactor}))`
    }
  }
}, 'text-legal');
export const [legalMedium, legalMediumStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.legalMedium.family),
  fontSize: tokens.typography.legalMedium.size,
  lineHeight: tokens.typography.legalMedium.lineHeight,
  fontWeight: tokens.typography.legalMedium.weight,
  letterSpacing: tokens.typography.legalMedium.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.legalMedium.size}, calc(${tokens.typography.legalMedium.size}*${tokens.typography.legalMedium.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.legalMedium.lineHeight}, calc(${tokens.typography.legalMedium.lineHeight}*${tokens.typography.legalMedium.maxScaleFactor}))`
    }
  }
}, 'text-legal_medium');
export const [legalStrong, legalStrongStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.legalStrong.family),
  fontSize: tokens.typography.legalStrong.size,
  lineHeight: tokens.typography.legalStrong.lineHeight,
  fontWeight: tokens.typography.legalStrong.weight,
  letterSpacing: tokens.typography.legalStrong.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.legalStrong.size}, calc(${tokens.typography.legalStrong.size}*${tokens.typography.legalStrong.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.legalStrong.lineHeight}, calc(${tokens.typography.legalStrong.lineHeight}*${tokens.typography.legalStrong.maxScaleFactor}))`
    }
  }
}, 'text-legal_strong');
export const [navigationBar, navigationBarStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.navigationBar.family),
  fontSize: tokens.typography.navigationBar.size,
  lineHeight: tokens.typography.navigationBar.lineHeight,
  fontWeight: tokens.typography.navigationBar.weight,
  letterSpacing: tokens.typography.navigationBar.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.navigationBar.size}, calc(${tokens.typography.navigationBar.size}*${tokens.typography.navigationBar.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.navigationBar.lineHeight}, calc(${tokens.typography.navigationBar.lineHeight}*${tokens.typography.navigationBar.maxScaleFactor}))`
    }
  }
}, 'text-navigation_bar');
export const [navigationBarMedium, navigationBarMediumStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.navigationBarMedium.family),
  fontSize: tokens.typography.navigationBarMedium.size,
  lineHeight: tokens.typography.navigationBarMedium.lineHeight,
  fontWeight: tokens.typography.navigationBarMedium.weight,
  letterSpacing: tokens.typography.navigationBarMedium.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.navigationBarMedium.size}, calc(${tokens.typography.navigationBarMedium.size}*${tokens.typography.navigationBarMedium.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.navigationBarMedium.lineHeight}, calc(${tokens.typography.navigationBarMedium.lineHeight}*${tokens.typography.navigationBarMedium.maxScaleFactor}))`
    }
  }
}, 'text-navigation_bar_medium');
export const [navigationBarStrong, navigationBarStrongStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.navigationBarStrong.family),
  fontSize: tokens.typography.navigationBarStrong.size,
  lineHeight: tokens.typography.navigationBarStrong.lineHeight,
  fontWeight: tokens.typography.navigationBarStrong.weight,
  letterSpacing: tokens.typography.navigationBarStrong.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.navigationBarStrong.size}, calc(${tokens.typography.navigationBarStrong.size}*${tokens.typography.navigationBarStrong.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.navigationBarStrong.lineHeight}, calc(${tokens.typography.navigationBarStrong.lineHeight}*${tokens.typography.navigationBarStrong.maxScaleFactor}))`
    }
  }
}, 'text-navigation_bar_strong');
export const [buttonSm, buttonSmStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.buttonSm.family),
  fontSize: tokens.typography.buttonSm.size,
  lineHeight: tokens.typography.buttonSm.lineHeight,
  fontWeight: tokens.typography.buttonSm.weight,
  letterSpacing: tokens.typography.buttonSm.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.buttonSm.size}, calc(${tokens.typography.buttonSm.size}*${tokens.typography.buttonSm.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.buttonSm.lineHeight}, calc(${tokens.typography.buttonSm.lineHeight}*${tokens.typography.buttonSm.maxScaleFactor}))`
    }
  }
}, 'text-button_sm');
export const [buttonLg, buttonLgStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.buttonLg.family),
  fontSize: tokens.typography.buttonLg.size,
  lineHeight: tokens.typography.buttonLg.lineHeight,
  fontWeight: tokens.typography.buttonLg.weight,
  letterSpacing: tokens.typography.buttonLg.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.buttonLg.size}, calc(${tokens.typography.buttonLg.size}*${tokens.typography.buttonLg.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.buttonLg.lineHeight}, calc(${tokens.typography.buttonLg.lineHeight}*${tokens.typography.buttonLg.maxScaleFactor}))`
    }
  }
}, 'text-button_lg');
export const [fieldLabelSm, fieldLabelSmStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.mediumContrast),
  fontFamily: getFontFamily(tokens.typography.fieldLabelSm.family),
  fontSize: tokens.typography.fieldLabelSm.size,
  lineHeight: tokens.typography.fieldLabelSm.lineHeight,
  fontWeight: tokens.typography.fieldLabelSm.weight,
  letterSpacing: tokens.typography.fieldLabelSm.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.fieldLabelSm.size}, calc(${tokens.typography.fieldLabelSm.size}*${tokens.typography.fieldLabelSm.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.fieldLabelSm.lineHeight}, calc(${tokens.typography.fieldLabelSm.lineHeight}*${tokens.typography.fieldLabelSm.maxScaleFactor}))`
    }
  }
}, 'text-fieldLabel_sm');
export const [fieldLabelLg, fieldLabelLgStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.mediumContrast),
  fontFamily: getFontFamily(tokens.typography.fieldLabelLg.family),
  fontSize: tokens.typography.fieldLabelLg.size,
  lineHeight: tokens.typography.fieldLabelLg.lineHeight,
  fontWeight: tokens.typography.fieldLabelLg.weight,
  letterSpacing: tokens.typography.fieldLabelLg.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.fieldLabelLg.size}, calc(${tokens.typography.fieldLabelLg.size}*${tokens.typography.fieldLabelLg.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.fieldLabelLg.lineHeight}, calc(${tokens.typography.fieldLabelLg.lineHeight}*${tokens.typography.fieldLabelLg.maxScaleFactor}))`
    }
  }
}, 'text-fieldLabel_lg');
export const [fieldValueSm, fieldValueSmStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.fieldValueSm.family),
  fontSize: tokens.typography.fieldValueSm.size,
  lineHeight: tokens.typography.fieldValueSm.lineHeight,
  fontWeight: tokens.typography.fieldValueSm.weight,
  letterSpacing: tokens.typography.fieldValueSm.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.fieldValueSm.size}, calc(${tokens.typography.fieldValueSm.size}*${tokens.typography.fieldValueSm.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.fieldValueSm.lineHeight}, calc(${tokens.typography.fieldValueSm.lineHeight}*${tokens.typography.fieldValueSm.maxScaleFactor}))`
    }
  }
}, 'text-fieldValue_sm');
export const [fieldValueLg, fieldValueLgStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.fieldValueLg.family),
  fontSize: tokens.typography.fieldValueLg.size,
  lineHeight: tokens.typography.fieldValueLg.lineHeight,
  fontWeight: tokens.typography.fieldValueLg.weight,
  letterSpacing: tokens.typography.fieldValueLg.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.fieldValueLg.size}, calc(${tokens.typography.fieldValueLg.size}*${tokens.typography.fieldValueLg.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.fieldValueLg.lineHeight}, calc(${tokens.typography.fieldValueLg.lineHeight}*${tokens.typography.fieldValueLg.maxScaleFactor}))`
    }
  }
}, 'text-fieldValue_lg');
export const [fieldValueXl, fieldValueXlStyles] = style({
  color: fallbackVar(contextColors.main, tokens.color.background.highContrast),
  fontFamily: getFontFamily(tokens.typography.fieldValueXl.family),
  fontSize: tokens.typography.fieldValueXl.size,
  lineHeight: tokens.typography.fieldValueXl.lineHeight,
  fontWeight: tokens.typography.fieldValueXl.weight,
  letterSpacing: tokens.typography.fieldValueXl.letterSpacing,
  '@media': {
    [`screen and (max-width: ${breakpoints.mediaMd})`]: {
      fontSize: `min(${tokens.typography.fieldValueXl.size}, calc(${tokens.typography.fieldValueXl.size}*${tokens.typography.fieldValueXl.maxScaleFactor}))`,
      lineHeight: `min(${tokens.typography.fieldValueXl.lineHeight}, calc(${tokens.typography.fieldValueXl.lineHeight}*${tokens.typography.fieldValueXl.maxScaleFactor}))`
    }
  }
}, 'text-fieldValue_xl');
export const [clampAtLine1, clampAtLine1Styles] = style({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  WebkitLineClamp: 1
}, 'text-clamp_line_1');
export const [clampAtLine2, clampAtLine2Styles] = style({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  WebkitLineClamp: 2
}, 'text-clamp_line_2');
export const [clampAtLine3, clampAtLine3Styles] = style({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  WebkitLineClamp: 3
}, 'text-clamp_line_3');
export const [clampAtLine4, clampAtLine4Styles] = style({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  WebkitLineClamp: 4
}, 'text-clamp_line_4');
export const [shimmerDisplayLg, shimmerDisplayLgStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.display.lineHeight
}, 'text-shimmer_display_lg');
export const [shimmerDisplayLgStrong, shimmerDisplayLgStrongStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.displayStrong.lineHeight
}, 'text-shimmer_display_lg_strong');
export const [shimmerDisplayLgMedium, shimmerDisplayLgMediumStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.displayMedium.lineHeight
}, 'text-shimmer_display_lg_medium');
export const [shimmerDisplaySm, shimmerDisplaySmStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.displaySm.lineHeight
}, 'text-shimmer_display_sm');
export const [shimmerDisplaySmStrong, shimmerDisplaySmStrongStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.displaySmStrong.lineHeight
}, 'text-shimmer_display_sm_strong');
export const [shimmerDisplaySmMedium, shimmerDisplaySmMediumStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.displaySmMedium.lineHeight
}, 'text-shimmer_display_sm_medium');
export const [shimmerHeadingLg, shimmerHeadingLgStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.headingLg.lineHeight
}, 'text-shimer_heading_lg');
export const [shimmerHeadingLgStrong, shimmerHeadingLgStrongStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.headingLgStrong.lineHeight
}, 'text-shimer_heading_lg_strong');
export const [shimmerHeadingLgMedium, shimmerHeadingLgMediumStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.headingLgMedium.lineHeight
}, 'text-shimer_heading_lg_medium');
export const [shimmerHeadingSm, shimmerHeadingSmStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.headingSm.lineHeight
}, 'text-shimmer_heading_sm');
export const [shimmerHeadingSmStrong, shimmerHeadingSmStrongStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.headingSmStrong.lineHeight
}, 'text-shimmer_heading_sm_strong');
export const [shimmerHeadingSmMedium, shimmerHeadingSmMediumStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.headingSmMedium.lineHeight
}, 'text-shimmer_heading_sm_medium');
export const [shimmerBody, shimmerBodyStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.body.lineHeight
}, 'text-shimmer_body');
export const [shimmerBodyStrong, shimmerBodyStrongStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.bodyStrong.lineHeight
}, 'text-shimmer_body_strong');
export const [shimmerBodyMedium, shimmerBodyMediumStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.bodyMedium.lineHeight
}, 'text-shimmer_body_medium');
export const [shimmerCaption, shimmerCaptionStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.caption.lineHeight
}, 'text-shimmer_caption');
export const [shimmerCaptionStrong, shimmerCaptionStrongStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.captionStrong.lineHeight
}, 'text-shimmer_caption_strong');
export const [shimmerCaptionMedium, shimmerCaptionMediumStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.captionMedium.lineHeight
}, 'text-shimmer_caption_medium');
export const [shimmerTitle, shimmerTitleStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.title.lineHeight
}, 'text-shimmer_title');
export const [shimmerTitleStrong, shimmerTitleStrongStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.titleStrong.lineHeight
}, 'text-shimmer_title_strong');
export const [shimmerTitleMedium, shimmerTitleMediumStyles] = style({
  ...shimmerStyles.defaultStyles,
  height: tokens.typography.titleMedium.lineHeight
}, 'text-shimmer_title_medium');
__vanilla_filescope__.endFileScope();
